class SupernovaDetailCarousel extends window.BAO.CustomElement {
  constructor () {
    super()

    if (window.innerWidth >= 786 || this.els.slide.elements.length < 2) return

    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    const carousel = new window.KeenSlider685(this.els.slides.element, {
      loop: false,
      mode: 'snap',
      rtl: false,
      slides: {
        perView: 1.05,
        spacing: 15
      }
    })

    this.els.slides.element.classList.add(
      'sec-SupernoveDetails_Slides-initialised'
    )

    carousel.on('slideChanged', () => {
      this.els.dot.elements.forEach((dot, index) => {
        dot.setAttribute('aria-current', carousel.track.details.rel === index)
      })
    })

    return carousel
  }

  get shouldUpdate () {
    return this.counter++ % this.updateRate === 0
  }
}

if (!customElements.get('supernova-detail-carousel')) {
  customElements.define('supernova-detail-carousel', SupernovaDetailCarousel)
}
